import React, { useEffect, useRef, useState } from 'react';
import '../styles.css';
//internal and external componentscontainers
import { Typography, Paper, Box, Fade, Popper, ClickAwayListener, Button, ThemeProvider, createTheme, Skeleton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faXmark,faFileExcel, faPlus } from '@fortawesome/free-solid-svg-icons';
import SelectBoxPrimary from '../../../components/SelectBoxPrimary';
import Textarea from '@mui/joy/Textarea';
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import ActionsTable from '../../../components/ActionsTable';
import { AvatarAndName } from '../../../components/AvatarAndName';
import { EvidenceWrapper } from '../../../components/EvidenceWrapper';
import { colors } from '../../../common/pallette/colors';
import { getStandardsEvidences, getStandardsSelfAssessmentComment, getStandrdsActions } from '../../../api/evaluation';
import { useDispatch, useSelector } from 'react-redux';
import { setActionsList, setProjectList, setSaActions, setSaComments, setSaEvidences, setStaffList } from '../../../redux/reducers/evaluation';
import EvidenceList from '../../../components/EvidenceList';
import { getAllActions } from '../../../api/action';
import { getStaff } from '../../../api/user';
import { getProjectsByClub } from '../../../api/club';
import { evidenceToStandard, uploadFile } from '../../../api/evidence';
import { formatDateTime, genUID } from '../../../common/StaticExports';
import EvidencesTable from '../../../components/EvidencesTable';
import SplitButton from '../../../components/SplitButton';
import EvidencePopup from '../../../components/EvidencePopup';
import { baseUrl } from '../../../api/config';
import { useTranslation } from 'react-i18next';

const theme = createTheme({
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: 50
                },
            }
        },
    }
})


const InterviewStandardDetails = (props: any) => {
    const { detail, manageUpdate } = props;
    const currentClub = useSelector((state:any) => state.clubDetails);
    const [addAction, setAddAction] = React.useState(false);
    const [addEvidence, setAddEvidence] = React.useState(false);
    const [isOpenLibModal, setIsOpenLibModal] = React.useState(false);
    const actions = useSelector((state:any) => state.evaluation.saActions);
    const evidences = useSelector((state:any) => state.evaluation.saEvidences);
    const selfAssessmentComment = useSelector((state:any) => state.evaluation.saComments);
    const [isLoadingActions, setIsLoadingActions] = useState(false);
    const [isLoadingEvidences, setIsLoadingEvidences] = useState(false);
    const [isAddAcionLoad, setIsAddAcionLoad] = useState(false);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);
    const dispatch = useDispatch();
    const fileInputRef:any = useRef(null);
    const [t] = useTranslation();
    const [onsiteData, setOnSiteData] = React.useState(detail);

    React.useEffect(() => {
    setOnSiteData(detail);
    }, [detail]);
    
    const tableHead = [
        {
            key: '', displayName: '',
        },
        {
            key: 'status', displayName: 'status',
        },
        {
            key: 'actionComment', displayName: 'action',
        },
        {
            key: 'description', displayName: 'description',
        },
        {
            key: 'dueDate', displayName: 'due date',
        },
        {
            key: 'owner', displayName: 'owner',
        },
        {
            key: 'isComplete', displayName: 'complete',
        },
        {
            key: '', displayName: '',
        },
      ];

      React.useEffect(() => {
        if(detail?.standardId && currentClub?.standardId) {
            const fetchActions = async () => {
                setIsLoadingActions(true);
                const response = await getStandrdsActions({standardId: detail.standardId, clubId: currentClub.id});
                return response;
            }
    
            const fetchEvidences = async () => {
                setIsLoadingEvidences(true);
                const response = await getStandardsEvidences({standardId: detail.standardId, clubId: currentClub.id});
                return response;
            }
    
            const fetchSelfAssessmentComments = async () => {
                const response = await getStandardsSelfAssessmentComment({standardId: detail.standardId, clubId: currentClub.id});
                return response;
            }
    
            !isLoadingActions &&
            fetchActions().then((res) => {
                dispatch(setSaActions(res));
                setIsLoadingActions(false);
            });
            fetchEvidences().then((res) => {
                dispatch(setSaEvidences(res));
                setIsLoadingEvidences(false);
            });
            fetchSelfAssessmentComments().then((res) => {
                dispatch(setSaComments(res));
            });
        }
      }, [detail, currentClub]);

      const manageAddAction = () => {
        const fetchActionList = async () => {
            setIsAddAcionLoad(true);
            const response = await getAllActions({ clubId: currentClub.id, isSelfAssessment: true });
            return response;
        }
        const fetchStaffList = async () => {
            const response = await getStaff({clubId: currentClub.id});
            return response;
        }
        const fetchClubProject = async () => {
            const response = await getProjectsByClub({clubId: currentClub.id});
            return response;
        }

        if(currentClub?.id) {
            fetchActionList().then((res) => {
                dispatch(setActionsList(res));
            });
            fetchStaffList().then((res) => {
                dispatch(setStaffList(res));
            });
            fetchClubProject().then((res) => {
                dispatch(setProjectList(res));
                setIsAddAcionLoad(false);
            });
        }
        setAddAction(true);
      }

      const handleFileChange = (e:any) => {
        
        const params:any = {
            clubId: currentClub.id,
            standardId: detail.standardId,
            file: e.target.files[0],
            standardKind: 0,
            currentFolderId: 0
        }

        const fileUpload = async () => {
            const response = await uploadFile(params);
            return response;
        }

        e.target.files[0] && currentClub.id && detail.standardId &&
        fileUpload().then((res) => {
            const tempArr:any = [...evidences, res];
            dispatch(setSaEvidences(tempArr));
            setAddEvidence(false);
        })
      }

      const manageEvidenceClick = (label:any) => {
        switch(label) {
            case 'Add Evidence':
                fileInputRef.current.click();
                setAddEvidence(true);
                break;
            case 'Add Evidence From Library':
                setAddEvidence(true);
                setIsOpenLibModal(true);
                break;
        }
      }

      const linkLibraryFile = (fileData:any) => {
        const linkToStandard = async () => {
            const response = await evidenceToStandard({fileId: fileData.id, standardId: detail.standardId});
            return response;
        }
        linkToStandard().then((res) => {
            const tempArr:any = [...evidences, res];
            dispatch(setSaEvidences(tempArr));
            setAddEvidence(false);
            setIsOpenLibModal(false);
        })
      }

    const manageOnsiteStandardUpdate = (key:any, updatedValue:any) => {
        const tempData = { ...detail, [key]: updatedValue };
        setOnSiteData(tempData);
    }

    return(
        <React.Fragment>
            <Box className={'detailsWrapper'} sx={{ mt: 0 }}>
                <Typography className='fs13 fw700'>{ genUID(onsiteData.standardUid) + ' ' + onsiteData.standardName}</Typography>
                <Typography className='fs13'>{onsiteData.description}</Typography>
            </Box>
            <Box className={'standardDetailsContainer mb20'}>
                {/* <Box className={'detailsWrapper'}>
                    <Typography className='standardsHeading uppercase'>Actions</Typography>
                    <Button className={!isAdmin ? 'smallButton' : 'displayNone'} 
                    sx={{ float: 'right' }} disableElevation 
                    onClick={() => {manageAddAction()}} variant='contained' size='small' 
                    startIcon={<FontAwesomeIcon className='fs12' icon={faPlus} />} disabled={addAction}>
                        {'Add Action'}
                    </Button>
                    <Box sx={{ mt: !isAdmin ? 6 : 0 }}>
                        <ActionsTable data={actions}
                            head={tableHead}
                            currentStandard={detail}
                            isAction={false} 
                            addAction={addAction} 
                            isLoading={isLoadingActions} 
                            isAddLoading={isAddAcionLoad}
                            bg={'#FAFAFA'}
                            handleClick={() => setAddAction(false)}/>
                    </Box>
                </Box> */}
                {/* <Box className={'detailsWrapper'}>
                    <Typography className='standardsHeading uppercase'>Evidence</Typography>
                    <EvidencePopup isOpen={isOpenLibModal} 
                    manageFileSelect={(d:any) => {linkLibraryFile(d)}}
                    manageClickAway={() => {setIsOpenLibModal(false)}}/>
                    {
                        !isAdmin &&
                        <>
                            <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                            />
                            <Box sx={{ float: 'right' }}>
                                <SplitButton 
                                options={['Add Evidence', 'Add Evidence From Library']}
                                handleClick={(e:any) => {manageEvidenceClick(e)}}/>
                            </Box>
                        </>
                    }
                        <Box sx={{ mt:!isAdmin ? 6 : 0 }}>
                            <EvidencesTable data={evidences} isLoading={isLoadingEvidences} bg={'#FAFAFA'}/>
                        </Box>
                </Box> */}
                <Box className={'detailsWrapper'}>
                    <Typography className='standardsHeading uppercase'>{t('COMMENTS')}</Typography>
                    <Box className={'sdCommentsWrapper'}>
                        <JoyCssVarsProvider>
                            <Textarea
                            sx={{ borderRadius: '6px', mt: 0, mb: '20px', width: '80%'}} 
                            disabled={false}
                            placeholder='Add comment' 
                            minRows={4} maxRows={4} 
                            onChange={(e:any) => {manageOnsiteStandardUpdate('comment', e.target.value)}}
                            value={onsiteData?.comment || ''}/>
                        </JoyCssVarsProvider>
                        <Box className={'SDuserDetailsWrapper'}>
                            {
                                onsiteData?.firstName != null &&
                                onsiteData?.firstName != ''&&
                                <>
                                <AvatarAndName avatarName={onsiteData?.firstName ? `${onsiteData.firstName} ${onsiteData.lastName}` : 'Undefined'}
                                avatarImage={onsiteData.avatarPath ? `${baseUrl}/Content${onsiteData.avatarPath}` : ''} />
                                <Typography className='fs12' sx={{ ml: '32px', mb: '10px' }}>{formatDateTime(onsiteData.updatedDate)}</Typography>
                                </>
                            }
                            <SelectBoxPrimary
                            label={''} 
                            report={'siteReview'} 
                            options={[0, 1, 2, 3]} 
                            isStatus={true} 
                            manageChange={(e:any) => {manageOnsiteStandardUpdate('status', e)}}
                            selected={onsiteData?.status || 0} />
                            <Button className='smallButton' 
                            sx={{ zIndex: 9, width: '34px', mt: '50px' }} 
                            disableElevation 
                            onClick={() => manageUpdate(onsiteData)} 
                            variant='contained' 
                            size='small' >
                                {'Done'}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </React.Fragment>
    )
}

export default InterviewStandardDetails;